import { index, jsonb, pgEnum, pgTable, text, timestamp, uuid } from "drizzle-orm/pg-core";
import { procurements } from "./procurement";

export const procurementEventActorEnum = pgEnum("procurement_event_actor", ["ADMIN", "SYSTEM"]);

/**
 * Append-only unit movement log. Writer: unit transitions (admin and system).
 */
export const procurementEvents = pgTable(
  "procurement_events",
  {
    id: uuid("id").primaryKey().defaultRandom(),
    procurementId: uuid("procurement_id")
      .notNull()
      .references(() => procurements.id),
    fromStatus: text("from_status"),
    toStatus: text("to_status").notNull(),
    actorType: procurementEventActorEnum("actor_type").notNull(),
    actorId: text("actor_id"),
    reason: text("reason"),
    metadata: jsonb("metadata"),
    createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
  },
  (t) => [index("procurement_events_procurement_idx").on(t.procurementId, t.createdAt)],
);
